import type { EditorThemeClasses } from 'lexical';

/**
 * Minimal MUI-aware Lexical theme. Class names are stable hooks for styling;
 * v3.0 keeps styling light (the ContentEditable carries base font/spacing
 * inline). Richer block styling can attach to these classes later without
 * touching the editor wiring.
 */
export const writerLabLexicalTheme: EditorThemeClasses = {
  paragraph: 'wl-paragraph',
  heading: {
    h1: 'wl-h1',
    h2: 'wl-h2',
    h3: 'wl-h3',
  },
  quote: 'wl-quote',
  list: {
    ul: 'wl-ul',
    ol: 'wl-ol',
    listitem: 'wl-li',
  },
  code: 'wl-code',
  text: {
    bold: 'wl-bold',
    italic: 'wl-italic',
    underline: 'wl-underline',
    code: 'wl-text-code',
  },
};
